import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  ListItem,
  ListItemText,
  ListItemIcon, Box
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import langConf from 'src/translations/langConf';

import DDButton from '../../Inputs/DropDownSelector/DDButton';

let LANG_OPTIONS;
let DEFAULT_LANG;

(async function computeLanguageOptions() {
  const defaultLang = langConf.defaultLanguage.appFormat;
  const options = await Promise.all(langConf.allowedLanguages.map(async (lang) => {
    const language = lang.appFormat;
    return ({
      value: language,
      // eslint-disable-next-line global-require,import/no-dynamic-require
      image: await require(`../../../images/flags/flag_${language.toLowerCase()}.png`)
    });
  }));
  LANG_OPTIONS = options;
  DEFAULT_LANG = options.find((lang) => lang.value === defaultLang);
}());

const styles = () => ({
  icon: {
    height: 18,
    width: 26
  },
  langSelect: {
    padding: 0
  },
  item: {
    cursor: 'pointer'
  }
});

function LangSelect({
  selectedLang,
  handleChangeOfLang,
  classes
}) {
  const titleElement = useMemo(() => {
    const lang = LANG_OPTIONS.find((opt) => opt.value === selectedLang.toUpperCase());
    return (
      <Box display="flex" alignItems="center">
        <ListItemIcon>
          <img
            src={lang?.image}
            alt={lang?.value}
            className={classes.icon}
          />
        </ListItemIcon>
        <ListItemText primary={lang?.value} />
      </Box>
    );
  }, [classes, selectedLang]);

  return (
    <DDButton
      titleElement={titleElement}
      listWidth={160}
      buttonWidth="100%"
    >
      {LANG_OPTIONS.map(({ value, image }) => (
        <ListItem
          key={value}
          onClick={() => handleChangeOfLang(value)}
          selected={value === selectedLang}
          className={classes.item}
        >
          <ListItemIcon>
            <img
              src={image}
              alt={value}
              className={classes.icon}
            />
          </ListItemIcon>
          <ListItemText primary={value} />
        </ListItem>
      ))}
    </DDButton>
  );
}

LangSelect.propTypes = {
  selectedLang: PropTypes.string,
  handleChangeOfLang: PropTypes.func.isRequired,
  classes: PropTypes.object
};

LangSelect.defaultProps = {
  selectedLang: DEFAULT_LANG,
  classes: {}
};

export default withStyles(styles)(LangSelect);
